module.exports = __webpack_public_path__ + "images/berufsstart.png?d78ded980fd4621d25bf82f30c47b2de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/berufsstart.png
// module id = lFsA
// module chunks = 0